function initTestimonialCarousel(root) {
  if (root.dataset.tstmBound) return;
  root.dataset.tstmBound = '1';

  const slides = Array.from(root.querySelectorAll('[data-tstm-slide]'));
  const dots = Array.from(root.querySelectorAll('[data-tstm-dot]'));
  if (slides.length < 2) return;

  let index = slides.findIndex((s) => s.classList.contains('is-active'));
  if (index < 0) index = 0;

  function show(next) {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    dots.forEach((dot, i) => {
      const on = i === index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      show(parseInt(dot.dataset.tstmDot, 10) || 0);
      restart();
    });
  });

  const autoplay = root.dataset.tstmAutoplay === 'true';
  let timer = null;
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function start() {
    if (!autoplay || timer) return;
    timer = setInterval(() => show(index + 1), 6000);
  }
  function restart() { stop(); start(); }

  if (autoplay) {
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
      }, { threshold: 0.2 }).observe(root);
    } else {
      start();
    }
  }

  show(index);
}

function initAllTestimonialCarousels() {
  document.querySelectorAll('[data-tstm-carousel]').forEach(initTestimonialCarousel);
}
initAllTestimonialCarousels();

document.addEventListener('shopify:section:load', initAllTestimonialCarousels);
